import { NextRequest } from "next/server";
import { apiOk } from "@/lib/api-auth";

export const runtime = "nodejs";

// Public: GET /api/v1/healthz — open, no auth
export async function GET(_req: NextRequest) {
  return apiOk({ ok: true, ts: new Date().toISOString(), service: "finzone-v2" });
}
